import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaArrowLeft,
  FaSave,
  FaUserEdit
} from "react-icons/fa";

import api from "../utils/api";
import "./EditProfile.css";

const EditProfile = () => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    address: "",
    ward: ""
  });

  const [originalData, setOriginalData] = useState({});

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {

    try {

      const res = await api.get("/me");

      const user = res.data.data || res.data;

      setOriginalData(user);

      setForm({
        name: user.name || "",
        mobile: user.mobile || "",
        address: user.address || "",
        ward: user.ward || ""
      });

    } catch (err) {

      console.error(err);
      toast.error("Unable to load profile");

    } finally {

      setLoading(false);

    }

  };

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  const saveProfile = async (e) => {

    e.preventDefault();

    if (!form.name.trim()) {
      toast.error("Name is required");
      return;
    }

    if (
      form.name === (originalData.name || "") &&
      form.mobile === (originalData.mobile || "") &&
      form.address === (originalData.address || "") &&
      form.ward === (originalData.ward || "")
    ) {
      toast.info("No changes detected");
      return;
    }

    try {

      setSaving(true);

      await api.put("/me", form);

      toast.success("Profile updated successfully");

      setOriginalData({
        ...form
      });

      setIsEditing(false);

    } catch (err) {

      console.error(err);

      toast.error(
        err?.response?.data?.message ||
        "Profile update failed"
      );

    } finally {

      setSaving(false);

    }

  };

  if (loading) {

    return (
      <div className="edit-loading">
        Loading Profile...
      </div>
    );

  }

  return (

    <div className="edit-profile-page">

      <div className="edit-profile-card">

        <div className="edit-header">

          <button
            className="back-btn"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft />
          </button>

          <h2>Edit Profile</h2>

        </div>

        <form onSubmit={saveProfile}>

          <div className="form-group">

            <label>Full Name</label>

            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              disabled={!isEditing}
            />

          </div>

          <div className="form-group">

            <label>Mobile Number</label>

            <input
              type="text"
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              disabled={!isEditing}
            />

          </div>

          <div className="form-group">

            <label>Address</label>

            <textarea
              rows="4"
              name="address"
              value={form.address}
              onChange={handleChange}
              disabled={!isEditing}
            />

          </div>

          <div className="form-group">

            <label>Ward</label>

            <input
              type="text"
              name="ward"
              value={form.ward}
              onChange={handleChange}
              disabled={!isEditing}
            />

          </div>

                    <div className="button-group">

            {!isEditing ? (

              <>
                <button
                  type="button"
                  className="edit-btn"
                  onClick={() => setIsEditing(true)}
                >
                  <FaUserEdit />
                  &nbsp; Edit Profile
                </button>

                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => navigate(-1)}
                >
                  <FaArrowLeft />
                  &nbsp; Back
                </button>
              </>

            ) : (

              <>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => {

                    setForm({
                      name: originalData.name || "",
                      mobile: originalData.mobile || "",
                      address: originalData.address || "",
                      ward: originalData.ward || ""
                    });

                    setIsEditing(false);

                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="save-btn"
                  disabled={saving}
                >
                  <FaSave />

                  &nbsp;

                  {saving
                    ? "Saving..."
                    : "Save Changes"}
                </button>

              </>

            )}

          </div>

        </form>

      </div>

    </div>

  );

};

export default EditProfile;